<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <div class="contents">
        <b-form @submit.prevent="passes(onSubmit)">
          <div class="row g-0 table-type header-col">
            <div class="col-sm-4">
              <span class="required">{{ $t("title.admin.grade") }}</span>
            </div>
            <div class="col-sm-8">
              <select class="form-select-lg" v-model="form.grade" required>
                <option value="0" disabled>
                  {{ $t("title.admin.grade") }}
                </option>
                <option
                  :value="index + 1"
                  v-for="(val, index) in Array(10)"
                  :key="index + 's'"
                >
                  {{ index + 1 }}
                </option>
              </select>
            </div>

            <div class="col-sm-4">
              <span class="required"
                >{{ $t("title.common.point") }}
                {{ $t("title.common.type") }}</span
              >
            </div>
            <div class="col-sm-8">
              <select
                class="form-select-lg"
                v-model="form.xpoint_type"
                required
              >
                <option value="0" disabled>
                  {{ $t("title.common.point") }} {{ $t("title.common.type") }}
                </option>
                <option value="1">{{ $t("text.admin.regular") }}</option>

                <option value="2">{{ $t("text.admin.major") }}</option>
                <option value="3">{{ $t("text.admin.novelty") }}</option>
              </select>
            </div>
            <div class="col-sm-4">
              <span class="required">{{ $t("title.admin.range1") }}</span>
            </div>
            <div class="col-sm-8">
              <input
                type="text"
                placeholder=""
                v-model="form.range1"
                required
              />
            </div>

            <div class="col-sm-4">
              <span class="required">{{ $t("title.admin.range2") }}</span>
            </div>
            <div class="col-sm-8">
              <input
                type="text"
                placeholder=""
                v-model="form.range2"
                required
              />
            </div>

            <div class="col-sm-4">
              <span class="required">{{
                $t("title.common.standard_point")
              }}</span>
            </div>
            <div class="col-sm-8">
              <input
                type="text"
                placeholder=""
                v-model="form.standard_point"
                required
                class="text-point-sp"
              />
            </div>

            <div class="col-sm-4">
              <span class="required">{{ $t("title.common.oom_point") }}</span>
            </div>
            <div class="col-sm-8">
              <input
                type="text"
                placeholder=""
                v-model="form.oom_point"
                required
                class="text-point-op"
              />
            </div>
          </div>

          <div class="btn-bottom-wrapper">
            <b-button
              size="xl"
              variant="outline-primary"
              :aria-label="$t('button.common.list')"
              @click="$router.push({ name: 'XpointList' })"
              >{{ $t("button.common.list") }}</b-button
            >
            <b-button
              size="xl"
              variant="primary"
              :aria-label="$t('button.common.save')"
              type="submit"
              >{{ $t("button.common.save") }}</b-button
            >
          </div>
        </b-form>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import "@/filter/common";

import { ValidationObserver } from "vee-validate";

import ax from "@/api/manager";

export default {
  name: "XpointWrite",
  components: {
    ValidationObserver,
  },
  data() {
    return {
      form: {
        xpoint_type: 0,
        grade: 0,
        title: "",
        range1: 1,
        range2: 1,
        standard_point: 0,
        oom_point: 0,
      },

      xpoint_pk: this.$route.params.xpoint_pk || 0,
    };
  },
  methods: {
    onSubmit() {
      // 등록
      ax.set_xpoint(this.form, this.xpoint_pk, (flag, data) => {
        if (flag) {
          alert(data.message);
          this.$router.push({ name: "XpointList" });
        } else {
          alert(data.message);
          return false;
        }
      });
    },
    getView() {
      ax.get_xpointview(this.xpoint_pk, (flag, data) => {
        if (flag) {
          this.form = data.xpointinfo;
        } else {
          alert(data.message);
        }
      });
    },
  },
  created() {
    if (this.xpoint_pk) {
      this.getView();
    }
  },
};
</script>